export const SimulatorIcon = ({ className = '', fill = '#fff' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="126"
    height="126"
    fill="none"
    viewBox="0 0 126 126"
    className={className}
  >
    <rect width="124.4" height="94.242" x="1" y="16" fill="#004E8F" rx="47.121"></rect>
    <path
      stroke="#fff"
      strokeLinejoin="round"
      strokeWidth="4.745"
      // eslint-disable-next-line max-len
      d="M90.059 36.261H36.341a4.477 4.477 0 00-4.477 4.477V76.55a4.477 4.477 0 004.477 4.476h53.718a4.477 4.477 0 004.477-4.476V40.738a4.477 4.477 0 00-4.477-4.477z"
    ></path>
    <path
      fill={fill}
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="4.745"
      d="M69.915 89.98l-1.12-8.954h-11.19l-1.12 8.953h13.43z"
    ></path>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="4.745"
      d="M78.868 89.98H47.532"
    ></path>
    <path
      fill={fill}
      // eslint-disable-next-line max-len
      d="M31.864 69.835v6.715a4.489 4.489 0 004.477 4.476h53.718a4.49 4.49 0 004.477-4.476v-6.715H31.864zM63.2 78.788a2.238 2.238 0 110-4.477 2.238 2.238 0 010 4.477z"
    ></path>
  </svg>
)
